import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    flexShrink: 0
  },
  video: {
    marginTop: 'auto',
    width: '100%'
  }
}))

export default useStyles
